import { TranslateService } from "@ngx-translate/core";
import printJS from 'print-js';


export class UTILS{
    constructor() {}
    
    deepCopy(obj: any) : any {
        var copy : any;
    
        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;
    
        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
    
        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.deepCopy(obj[i]);
            }
            return copy;
        }
    
        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
            }
            return copy;
        }
    
        throw new Error("Unable to copy obj! Its type isn't supported.");
    }

    parseFloat(val: string): string{
      let returnVal : string = "";
      if(!isNaN(parseFloat(val))){
        returnVal = ("" + parseFloat(val).toFixed(2)).replace(/,/, '.');
      } else {
        returnVal = "";
      }
      return returnVal;
    }

    downloadFile(applicationType: string, base64String: string, fileName: string){
        const source = `data:`+ applicationType +`;base64,${base64String}`; //application/pdf; application/xml
        const link = document.createElement("a");
        link.href = source;
        link.download = `${fileName}`; // + format;
        link.click();
    }

    downloadFromSource(url : string, fileName : string) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${fileName}`; // + format;
        link.click();
    }

    printFromSource(url : string, fileName : string) {
      printJS({printable:url, type:'pdf', showModal:true, documentTitle: fileName})
    }

    viewDoc(content: string){
        var byteCharacters = atob(content);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], {type: "application/pdf"});
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
    }

    getFileUrl(content: string) : string{
      var byteCharacters = atob(content);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {type: "application/pdf"});
      return URL.createObjectURL(blob);
    }

    async getTranslateTitle(translate: TranslateService, val: string): Promise<string> {
        return new Promise((resolve, reject) => {
          if(val && translate){
            translate.get(val).subscribe((res: string) => {
              resolve(res);
            }, error => {
              reject(val)
            });
          } else {
            resolve(val);
          }
        });
      }
}